var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{ref:"fileInput",attrs:{"rules":"file_size","vid":_vm.vid,"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('file-uploader',{attrs:{"value":_vm._value},on:{"input":_vm.onInputFile}}),_c('BaseErrorMessage',{attrs:{"errors":errors.concat( _vm.responseFieldErrors)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }